import { FundRequestStatus } from "@/lib/api/fund";

export function getReadableStatusLabel(status: FundRequestStatus): string {
  switch (status) {
    case FundRequestStatus.Granted:
      return "Granted";
    case FundRequestStatus.AwaitingValidation:
      return "Awaiting Validation";
    case FundRequestStatus.FailedToParse:
      return "Failed to Parse";
    default:
      // Convert from snake_case to Title Case
      return (status as string).replace(/_/g, ' ')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
  }
}

export function getStatusBadgeColor(status: FundRequestStatus) {
  switch (status) {
    case FundRequestStatus.Granted:
      return "bg-green-100 text-green-800";
    case FundRequestStatus.AwaitingValidation:
      return "bg-yellow-100 text-yellow-800";
    case FundRequestStatus.FailedToParse:
      return "bg-red-100 text-red-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
}
